import { Injectable } from "@angular/core"
import { BinanceWebsocketClient } from "../../../market"
import { Observable } from "rxjs"
import { isWsFormattedFuturesAlgoUpdateEvent, isWsFormattedFuturesUserDataTradeUpdateEvent, WsUserDataEvents } from "libs/binance-api/src"
import { Order, OrderSide, OrderType, PositionSide } from "../../../model/trade"
import { parseFloatSafe } from "src/app/core/func"

@Injectable({
  providedIn: 'root'
})
export class BinanceOrderHandler {

  listen(ws: BinanceWebsocketClient) {
    return new Observable<Order>(subscriber => {
      const f = (data: WsUserDataEvents) => {
        if (isWsFormattedFuturesUserDataTradeUpdateEvent(data)) {
          const order: Order = {
            createdTimestamp: data.transactionTime,
            updateTimestamp: data.transactionTime,
            type: data.order.orderType == 'LIMIT' ? OrderType.limit : (data.order.orderType == 'MARKET' ? OrderType.market : OrderType.unknown),
            status: data.order.orderStatus,
            market: 'binance',
            board: 'usdm',
            symbol: data.order.symbol,
            price: data.order.originalPrice,
            quantity: data.order.originalQuantity,
            volume: data.order.originalPrice * data.order.originalQuantity,
            remainingQuantity: data.order.originalQuantity - data.order.orderFilledAccumulatedQuantity,
            remainingVolume: data.order.originalPrice * (data.order.originalQuantity - data.order.orderFilledAccumulatedQuantity),
            side: data.order.orderSide == 'BUY' ? OrderSide.buy : OrderSide.sell,
            positionSide: data.order.positionSide == 'LONG' ? PositionSide.long : data.order.positionSide == 'SHORT' ? PositionSide.short : PositionSide.both,
            orderId: data.order.orderId,
            clientOrderId: data.order.clientOrderId,
            isStop: data.order.orderType.includes('STOP'),
            isClosePosition: data.order.isReduceOnly,
          }
          if (order.isStop) {
            order.price = data.order.stopPrice
            order.volume = parseFloatSafe(order.price) * parseFloatSafe(order.quantity)
            order.remainingQuantity = order.quantity
            order.remainingVolume = order.volume
          }
          subscriber.next(order)
        }
        if (isWsFormattedFuturesAlgoUpdateEvent(data)) {
          const order: Order = {
            createdTimestamp: data.transactionTime,
            updateTimestamp: data.transactionTime,
            type: OrderType.market,
            status: data.algoOrder.algoStatus,
            market: 'binance',
            board: 'usdm',
            symbol: data.algoOrder.symbol,
            price: data.algoOrder.triggerPrice,
            quantity: data.algoOrder.quantity,
            volume: parseFloatSafe(data.algoOrder.triggerPrice) * parseFloatSafe(data.algoOrder.quantity),
            remainingQuantity: data.algoOrder.quantity,
            remainingVolume: parseFloatSafe(data.algoOrder.triggerPrice) * parseFloatSafe(data.algoOrder.quantity),
            side: data.algoOrder.side == 'BUY' ? OrderSide.buy : OrderSide.sell,
            positionSide: data.algoOrder.positionSide == 'LONG' ? PositionSide.long : data.algoOrder.positionSide == 'SHORT' ? PositionSide.short : PositionSide.both,
            orderId: data.algoOrder.algoId,
            clientOrderId: data.algoOrder.clientAlgoId,
            isStop: true,
            isClosePosition: data.algoOrder.reduceOnly,
          }
          subscriber.next(order)
        }
      }

      ws.on('formattedUserDataMessage', f)
      return () => ws.off('formattedUserDataMessage', f)
    })
  }

}
